


















import { Vue, Component, Prop } from "vue-property-decorator";

import CloseSvg from '../../../../assets/svg/close-rounded.svg';

@Component({ components: { CloseSvg } })

export default class CommitteeLayout extends Vue {
    @Prop({ required: true }) title: string;
}

